import { useEffect } from "react";

/** Events Redo listens for */
export enum RedoListenedDomEvent {
  ReloadCart = "redo:reload-cart", // Fired by the merchant when the they have added/removed items from the cart and so we should re-calculate Redo price
}

/** Events Redo emits onto document body */
export enum RedoEmittedDomEvent {
  // Cart product changes
  RenderCart = "redo:render-cart", // Fired when we have added/removed redo from the cart and the theme may need to re-render cart elements (usually only relevant for toggles/cart card, not checkout buttons)

  // Elements rendering
  CheckoutButtonsRendered = "redo:checkout-buttons-rendered",
  InfoCardRendered = "redo:info-card-rendered",
  ToggleRendered = "redo:toggle-rendered", // Fired by the actual classic redo toggle only! A button is not a toggle (to a merchant, at least). Deluxe toggle array may fire multiple of these. Use the event DeluxeToggleArrayRendered to get it only once
  DeluxeToggleArrayRendered = "redo:deluxe-toggle-array-rendered",
  CartCardRendered = "redo:cart-card-rendered",
  PdpCheckboxRendered = "redo:pdp-checkbox-rendered",
}

export const useFireEventOnRender = (eventToEmit: RedoEmittedDomEvent) => {
  useEffect(() => {
    requestAnimationFrame(() => {
      document.body.dispatchEvent(new CustomEvent(eventToEmit));
    });
  }, [eventToEmit]);
};
